import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';
import { baseInputClass } from '../constants';

interface PasswordInputProps {
  disabled: boolean;
}

export const PasswordInput = ({ disabled }: PasswordInputProps) => {
  const [value, setValue] = useState('');
  const [show, setShow] = useState(false);

  return (
    <div className="space-y-2">
      {/* <div className="flex items-center gap-2 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                <Lock size={18} className="text-purple-600" />
                <span className="text-sm text-purple-800 font-medium">
                    Masked / Password Text
                </span>
            </div> */}

      <div className="relative">
        <input
          type={show ? 'text' : 'password'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Enter your answer here"
          className={`${baseInputClass} pr-10`}
          disabled={disabled}
        />
        <button
          type="button"
          onClick={() => setShow(!show)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
          disabled={disabled}
        >
          {show ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>

      {value && <div className="text-xs text-gray-500">Length: {value.length} characters</div>}
    </div>
  );
};
